var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.event
    ? _c(
        "div",
        {
          staticClass: "coupon-event-wrapper",
          attrs: { idfoevent: _vm.event.idfoevent.toString() }
        },
        [
          _vm.isDebug
            ? _c("div", [
                _vm._v("\n    EVENT"),
                _c("br"),
                _vm._v(
                  "\n    event.idfoevent " + _vm._s(_vm.event.idfoevent) + " "
                ),
                _c("br"),
                _vm._v(
                  "\n    event.internalorder " +
                    _vm._s(_vm.event.internalorder) +
                    "\n  "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-layout",
            {
              class: [
                {
                  outright:
                    _vm.event &&
                    _vm.event.markets &&
                    _vm.event.markets[0] &&
                    (_vm.event.markets[0].isoutright || !_vm.event.ismatch)
                },
                {
                  outright3Plus:
                    _vm.event &&
                    _vm.event.markets &&
                    _vm.event.markets[0] &&
                    (_vm.event.markets[0].isoutright || !_vm.event.ismatch) &&
                    _vm.event.markets[0].selections.length > 3
                },
                { threeselections: _vm.threeselections },
                { "big3-event": _vm.isbig3coupon },
                {
                  "selections-three-plus":
                    (_vm.event.markets &&
                      _vm.event.markets[0].selections.length > 3) ||
                    _vm.event.markets[0].isoutright
                },
                {
                  "selections-nine-plus":
                    _vm.event.markets &&
                    _vm.event.markets[0].selections.length > 9
                },
                {
                  twoselections:
                    _vm.twoselections &&
                    _vm.event.markets &&
                      _vm.event.markets[0].selections.length < 3 &&
                      !_vm.event.markets[0].isoutright
                },
                {
                  "coupon-threeselections":
                    _vm.event.markets &&
                    _vm.event.markets[0].selections.length === 3 &&
                    !_vm.event.markets[0].isoutright
                },
                _vm.event.markets[0].idfosporttype
              ],
              attrs: { "coupon-event": "" }
            },
            [
              _vm.awayParticipantName &&
              _vm.homeParticipantName &&
              (!_vm.event.markets || !_vm.isParticipantNamesBlockDisabled)
                ? _c("v-flex", { staticClass: "names participants" }, [
                    !_vm.isbig3coupon
                      ? _c(
                          "div",
                          {
                            staticClass: "event-info",
                            class: {
                              clickable: _vm.event.noofmarkets > 0,
                              "team-logos": _vm.teamLogoVisibility
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.goToEvent(
                                  _vm.event,
                                  false,
                                  false,
                                  false,
                                  false,
                                  false,
                                  _vm.idfwmarketgroup
                                )
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "eventTitle home" }, [
                              _vm.luListcode4ParticipantMake(
                                _vm.event,
                                "HOME"
                              ) !== ""
                                ? _c("span", { staticClass: "listcode" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.luListcode4ParticipantMake(
                                          _vm.event,
                                          "HOME"
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "event-info-name-wrapper" },
                                [
                                  _vm.teamLogoVisibility
                                    ? _c("span", {
                                        staticClass: "team-logo",
                                        style: _vm.homeTeamLogoStyle
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.teamLogoVisibility &&
                                  _vm.mobileBigAndBelow
                                    ? _c("span", { staticClass: "name" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.event.shortnamehome ||
                                              _vm.homeParticipantName
                                          )
                                        )
                                      ])
                                    : _vm.mobileBigAndBelow &&
                                      _vm.useShortParticipantNameOnMobile
                                    ? _c("span", { staticClass: "name" }, [
                                        _vm._v(
                                          _vm._s(_vm.homeParticipantShortName)
                                        )
                                      ])
                                    : _c("span", { staticClass: "name" }, [
                                        _vm._v(_vm._s(_vm.homeParticipantName))
                                      ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.event.homepitchername && _vm.isPitcherVisible
                                ? _c("span", { staticClass: "pitcher-name" }, [
                                    _c("span", { staticClass: "cell" }),
                                    _c("p", { staticClass: "cell" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("lowercase")(
                                            _vm.event.homepitchername
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "eventTitle away" }, [
                              _vm.luListcode4ParticipantMake(
                                _vm.event,
                                "AWAY"
                              ) !== ""
                                ? _c("span", { staticClass: "listcode" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.luListcode4ParticipantMake(
                                          _vm.event,
                                          "AWAY"
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "event-info-name-wrapper" },
                                [
                                  _vm.teamLogoVisibility
                                    ? _c("span", {
                                        staticClass: "team-logo",
                                        style: _vm.awayTeamLogoStyle
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.teamLogoVisibility &&
                                  _vm.mobileBigAndBelow
                                    ? _c("span", { staticClass: "name" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.event.shortnameaway ||
                                              _vm.awayParticipantName
                                          )
                                        )
                                      ])
                                    : _vm.mobileBigAndBelow &&
                                      _vm.useShortParticipantNameOnMobile
                                    ? _c("span", { staticClass: "name" }, [
                                        _vm._v(
                                          _vm._s(_vm.awayParticipantShortName)
                                        )
                                      ])
                                    : _c("span", { staticClass: "name" }, [
                                        _vm._v(_vm._s(_vm.awayParticipantName))
                                      ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.event.awaypitchername && _vm.isPitcherVisible
                                ? _c("span", { staticClass: "pitcher-name" }, [
                                    _c("span", { staticClass: "cell" }),
                                    _c("p", { staticClass: "cell" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("lowercase")(
                                            _vm.event.awaypitchername
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ])
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "event-info",
                            class: {
                              clickable: _vm.event.noofmarkets > 0,
                              "team-logos": _vm.teamLogoVisibility
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.goToEvent(
                                  _vm.event,
                                  false,
                                  false,
                                  false,
                                  false,
                                  false,
                                  _vm.idfwmarketgroup
                                )
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "eventTitle away" }, [
                              _vm.luListcode4ParticipantMake(
                                _vm.event,
                                "AWAY"
                              ) !== ""
                                ? _c("span", { staticClass: "listcode" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.luListcode4ParticipantMake(
                                          _vm.event,
                                          "AWAY"
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "event-info-name-wrapper" },
                                [
                                  _vm.teamLogoVisibility
                                    ? _c("span", {
                                        staticClass: "team-logo",
                                        style: _vm.awayTeamLogoStyle
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.teamLogoVisibility &&
                                  _vm.mobileBigAndBelow
                                    ? _c("span", { staticClass: "name" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.event.shortnameaway ||
                                              _vm.awayParticipantName
                                          )
                                        )
                                      ])
                                    : _vm.mobileBigAndBelow &&
                                      _vm.useShortParticipantNameOnMobile
                                    ? _c("span", { staticClass: "name" }, [
                                        _vm._v(
                                          _vm._s(_vm.awayParticipantShortName)
                                        )
                                      ])
                                    : _c("span", { staticClass: "name" }, [
                                        _vm._v(_vm._s(_vm.awayParticipantName))
                                      ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.event.awaypitchername && _vm.isPitcherVisible
                                ? _c("span", { staticClass: "pitcher-name" }, [
                                    _c("span", { staticClass: "cell" }),
                                    _c("p", { staticClass: "cell" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("lowercase")(
                                            _vm.event.awaypitchername
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "eventTitle home" }, [
                              _vm.luListcode4ParticipantMake(
                                _vm.event,
                                "HOME"
                              ) !== ""
                                ? _c("span", { staticClass: "listcode" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.luListcode4ParticipantMake(
                                          _vm.event,
                                          "HOME"
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "event-info-name-wrapper" },
                                [
                                  _vm.teamLogoVisibility
                                    ? _c("span", {
                                        staticClass: "team-logo",
                                        style: _vm.homeTeamLogoStyle
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.teamLogoVisibility &&
                                  _vm.mobileBigAndBelow
                                    ? _c("span", { staticClass: "name" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.event.shortnamehome ||
                                              _vm.homeParticipantName
                                          )
                                        )
                                      ])
                                    : _vm.mobileBigAndBelow &&
                                      _vm.useShortParticipantNameOnMobile
                                    ? _c("span", { staticClass: "name" }, [
                                        _vm._v(
                                          _vm._s(_vm.homeParticipantShortName)
                                        )
                                      ])
                                    : _c("span", { staticClass: "name" }, [
                                        _vm._v(_vm._s(_vm.homeParticipantName))
                                      ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.event.homepitchername && _vm.isPitcherVisible
                                ? _c("span", { staticClass: "pitcher-name" }, [
                                    _c("span", { staticClass: "cell" }),
                                    _c("p", { staticClass: "cell" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("lowercase")(
                                            _vm.event.homepitchername
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ])
                          ]
                        )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "market" },
                [
                  _vm.event.markets[0].isoutright &&
                  ["GOLF", "MOTORSPORT", "NASCAR"].indexOf(
                    _vm.event.markets[0].idfosporttype
                  ) === -1
                    ? _c(
                        "div",
                        { staticClass: "outright outright-event-name" },
                        [_vm._v(_vm._s(_vm.event.externaldescription))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.event.markets[0].isoutright &&
                  ["GOLF", "MOTORSPORT", "NASCAR"].indexOf(
                    _vm.event.markets[0].idfosporttype
                  ) !== -1
                    ? _c(
                        "div",
                        {
                          staticClass: "outright outright-event-name",
                          class: { hheader: _vm.showOutrightMarketname }
                        },
                        [_vm._v(_vm._s(_vm.event.externaldescription))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showOutrightMarketname
                    ? _c("div", [
                        _vm.event.markets[0].isoutright &&
                        ["GOLF", "MOTORSPORT", "NASCAR"].indexOf(
                          _vm.event.markets[0].idfosporttype
                        ) !== -1
                          ? _c("div", { staticClass: "outright-event-name" }, [
                              _vm._v(_vm._s(_vm.event.markets[0].name))
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("markets", {
                    staticClass: "markets-container",
                    attrs: {
                      markets: _vm.isbig3coupon
                        ? _vm.event.markets.filter(function(mk) {
                            return (
                              mk.gameperiod === "1+" &&
                              mk.selections &&
                              mk.selections.length <= 2
                            )
                          })
                        : [_vm.event.markets[0]],
                      event: _vm.event,
                      iscoupondisplay: !!_vm.event.participantname_away,
                      diplayOnPage: "coupon",
                      isbig3coupon: _vm.isbig3coupon,
                      isheadlinecoupon: true,
                      couponname: _vm.couponname
                    }
                  }),
                  _vm._v(" "),
                  !_vm.event.markets[0].isoutright &&
                  !_vm.mobileBigAndBelow &&
                  _vm.brandLayout !== "generic" &&
                  _vm.brandKey !== "sb" &&
                  _vm.brandKey !== "mav" &&
                  _vm.brandKey !== "qcasino" &&
                  !_vm.hasMarketWithThreePlusSelections &&
                  _vm.event.noofmarkets && _vm.event.noofmarkets > 0 &&
                  ["GOLF", "MOTORSPORT", "NASCAR"].indexOf(
                    _vm.event.markets[0].idfosporttype
                  ) === -1
                    ? _c(
                        "div",
                        {
                          staticClass: "more-markets",
                          class: { clickable: _vm.event.noofmarkets > 0 },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.goToEvent(
                                _vm.event,
                                false,
                                false,
                                false,
                                false,
                                false,
                                _vm.idfwmarketgroup
                              )
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("add")])],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showOutrightMarketname &&
                  ["GOLF", "MOTORSPORT", "NASCAR"].indexOf(
                    _vm.event.markets[0].idfosporttype
                  ) !== -1 &&
                  _vm.brandLayout !== "generic"
                    ? _c(
                        "div",
                        {
                          staticClass: "add more-markets",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.goToEvent(
                                _vm.event,
                                false,
                                false,
                                false,
                                false,
                                false,
                                _vm.idfwmarketgroup
                              )
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("Sports.Markets")))
                          ]),
                          _vm._v(" "),
                          _c("v-icon", [_vm._v("chevron_right")])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          (_vm.event.markets && _vm.event.markets[0].selections.length <= 9) ||
          !_vm.event.markets[0].isoutright
            ? _c(
                "section",
                {
                  staticClass: "single-coupon-footer",
                  class: { "live-streaming": _vm.isLiveStreamAvailable }
                },
                [
                  _c(
                    "div",
                    { staticClass: "time" },
                    [
                      _c("sgp-tag", {
                        attrs: {
                          markets: _vm.ksPreProcessEven(_vm.event).markets,
                          isLive: 0,
                          filterMarkets: "some",
                          isForCoupon: "couponEvent"
                        }
                      }),
                      _vm._v(" "),
                      _vm.isDateToday(_vm.event.tsstart)
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("BettingOffer.Today")) +
                                " " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.event.tsstart,
                                    _vm.dateFormats.longTime
                                  )
                                )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isDateTomorrow(_vm.event.tsstart)
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("BettingOffer.Tomorrow")) +
                                " " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.event.tsstart,
                                    _vm.dateFormats.longTime
                                  )
                                )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isDateToday(_vm.event.tsstart) &&
                      !_vm.isDateTomorrow(_vm.event.tsstart)
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("moment")(
                                  _vm.event.tsstart,
                                  _vm.dateFormats.longDateTimeMG
                                )
                              ) + " "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isStreamingAvailable
                        ? _c(
                            "div",
                            {
                              staticClass: "live-stream prematch",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.goToEvent(_vm.event)
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("BettingOffer.WatchLive")))
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "eventextdesc" }, [
                    _vm._v(_vm._s(_vm.event.externaldescription))
                  ]),
                  _vm._v(" "),
                  (_vm.brandLayout === "generic" ||
                    _vm.brandKey === "sb" ||
                    _vm.brandKey === "mav" ||
                    _vm.brandKey === "qcasino" ||
                    _vm.mobileBigAndBelow ||
                    _vm.event.markets[0].isoutright) &&
                  !_vm.hasMarketWithThreePlusSelections &&
                  _vm.event.noofmarkets && _vm.event.noofmarkets > 0 &&
                  ["GOLF", "MOTORSPORT", "NASCAR"].indexOf(
                    _vm.event.markets[0].idfosporttype
                  ) === -1
                    ? _c(
                        "div",
                        {
                          staticClass: "more-markets",
                          class: { clickable: _vm.event.noofmarkets > 0 },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.goToEvent(
                                _vm.event,
                                false,
                                false,
                                false,
                                false,
                                false,
                                _vm.idfwmarketgroup
                              )
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("Sports.Markets")))
                          ]),
                          _vm._v(" "),
                          _c("v-icon", [_vm._v("add")])
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f88211c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f88211c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/couponEvent.vue
// module id = null
// module chunks = 